<template>
  <div class="hopkinsIframeCard">
    <iframe
      :width="graphWidth"
      :style="{ height: `${chartHeight - 7}px` }"
      class="hopkinsIframe"
      title="Coronavirus COVID-19 Global Cases by Johns Hopkins CSSE"
      src="https://www.arcgis.com/apps/opsdashboard/index.html#/85320e2ea5424dfaaa75ae62e5c06e61"
    ></iframe>
  </div>
</template>

<script>
import Chart from "@/components/general-components/chart/Chart";
import AtomSpinnerCentred from "@/components/general-components/loading/AtomSpinnerCentred";
import { graphMixin } from "@/modules/dashboard/utilities/graphMixin";
import { mapState } from "vuex";

export default {
  mixins: [graphMixin],

  name: "GlobalStatisticsCard",
  components: { AtomSpinnerCentred, Chart },
  data() {
    return {
      styles: {
        "max-width": "100vw",
        position: "relative"
      },
      dataSets: [],
      dateRange: [],
      renderGraph: false,
      loading: true
    };
  },
  computed: {
    ...mapState(["chartHeight"])
  },
  methods: {}
};
</script>

<style>
.hopkinsIframeCard {
  padding-top: 5px;
  margin-bottom: -3px;
}

.hopkinsIframe {
  width: 100%;
  margin: 0;
  border: none;
}
</style>
